import * as React from "react";
import { ContextOrgDrawer } from "./ContextOrgDrawer";
import { ContextGvcDrawer } from "./ContextGvcDrawer";
import { useAppSelector } from "../../../../store/hooks";
import { selectContext } from "../../../../store/contextSlice";

export const ContextWidget: React.FC = () => {
  const context = useAppSelector(selectContext);
  const dashboard = useAppSelector((state) => state.uiData.dashboard);

  const [isOrgOpen, setIsOrgOpen] = React.useState(false);
  const [isGvcOpen, setIsGvcOpen] = React.useState(false);

  if (dashboard !== "console") {
    return null;
  }

  return (
    <>
      <div className="flex items-center mr-8 context-widget" data-guide="context-widget">
        <ContextOrgDrawer isOpen={isOrgOpen} setIsOpen={setIsOrgOpen}>
          <div
            tabIndex={0}
            onKeyDown={(e) => {
              if (e.code === "Enter" && !isOrgOpen) {
                setIsOrgOpen(true);
              }
            }}
            style={{
              borderColor: `var(--color-input-border)`,
              borderTopLeftRadius: 6,
              borderBottomLeftRadius: 6,
              borderTopRightRadius: 0,
              borderBottomRightRadius: 0,
            }}
            className={`border px-2 py-1 flex items-baseline gap-2 cursor-pointer context-widget-box context-widget-org ${
              isOrgOpen ? "active" : ""
            }`}
          >
            <div style={{ fontSize: 10 }} className="leading-tight uppercase">
              Org
            </div>
            <div className="leading-tight truncate context-widget-name">{context.org || "Select Org"}</div>
          </div>
        </ContextOrgDrawer>
        <ContextGvcDrawer isOpen={isGvcOpen} setIsOpen={setIsGvcOpen}>
          <div
            tabIndex={0}
            onKeyDown={(e) => {
              if (e.code === "Enter" && !isGvcOpen) {
                setIsGvcOpen(true);
              }
            }}
            style={{
              borderColor: `var(--color-input-border)`,
              borderTopLeftRadius: 0,
              borderBottomLeftRadius: 0,
              borderTopRightRadius: 6,
              borderBottomRightRadius: 6,
              borderLeftWidth: 0,
            }}
            className={`border px-2 py-1 flex justify-between cursor-pointer context-widget-box context-widget-gvc-parent ${
              isGvcOpen ? "active" : ""
            }`}
          >
            <div className={`flex items-baseline gap-2 context-widget-gvc ${isGvcOpen ? "active" : ""}`}>
              <div style={{ fontSize: 10 }} className="leading-tight uppercase">
                GVC
              </div>
              <div className="leading-tight truncate context-widget-name">{context.gvc || "All GVCs"}</div>
            </div>
          </div>
        </ContextGvcDrawer>
      </div>
    </>
  );
};
